import { ImgID } from "../../../image_loader/img_id.js";
import { UIElement } from "../../common_ui_elements/ui_element.js";
import { UIImage } from "../../common_ui_elements/ui_image.js";

export interface StarChestBox
{
  main: UIImage;
  top: UIImage;
}

export class StarChestArt
{
  static readonly MAIN_W = 354;
  static readonly MAIN_H = 199;
  static readonly OPEN_W = 353;
  static readonly OPEN_H = 187;
  static readonly CLOSE_W = 399;
  static readonly CLOSE_H = 284;
  static readonly OPEN_OFFSET_Y = 170;
  static readonly CLOSE_OFFSET_Y = 153;

  static createClosed( ctx: CanvasRenderingContext2D, content: UIElement, center_x: number, center_y: number, scale: number = 1 ): StarChestBox
  {
    return this.create( ctx, content, center_x, center_y, ImgID.UI_DailyTaskBoxClose, this.CLOSE_W, this.CLOSE_H, this.CLOSE_OFFSET_Y, scale );
  }

  static swapCapToOpen( cap: UIImage, center_x: number, center_y: number, scale: number ): void
  {
    const main_h = LayoutScaler.heightFromDesign( this.MAIN_H * scale );
    const main_y = center_y - main_h;

    const open_w = LayoutScaler.widthFromDesign( this.OPEN_W * scale );
    const open_h = LayoutScaler.heightFromDesign( this.OPEN_H * scale );
    const open_x = center_x - open_w / 2;
    const open_y = main_y - LayoutScaler.yFromDesign( this.OPEN_OFFSET_Y * scale );

    cap.setImageId( ImgID.UI_DailyTaskBoxOpen );
    cap.setBounds( open_x, open_y, open_w, open_h );
  }

  private static create( ctx: CanvasRenderingContext2D, content: UIElement, center_x: number, center_y: number, top_img_id: ImgID, top_design_w: number, top_design_h: number, top_offset_y: number, scale: number ): StarChestBox
  {
    const main_w = LayoutScaler.widthFromDesign( this.MAIN_W * scale );
    const main_h = LayoutScaler.heightFromDesign( this.MAIN_H * scale );

    const main_x = center_x - main_w / 2;
    const main_y = center_y - main_h;

    const main = new UIImage( ctx, main_x, main_y, main_w, main_h, ImgID.UI_DailyTaskBoxMain );
    content.addChild( main );

    const top_w = LayoutScaler.widthFromDesign( top_design_w * scale );
    const top_h = LayoutScaler.heightFromDesign( top_design_h * scale );

    const top_x = center_x - top_w / 2;
    const top_y = main_y - LayoutScaler.yFromDesign( top_offset_y * scale );

    const top = new UIImage( ctx, top_x, top_y, top_w, top_h, top_img_id );
    content.addChild( top );

    return { main, top };
  }
}
